import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./assets/css/demo.css";
ReactDOM.render(<App />, document.getElementById("root"));
